import { Routes, Route } from 'react-router'
import Layout from './components/Layout'
import Home from './pages/Home'
import TraficoSeresHumanos from './pages/TraficoSeresHumanos'
import OQueFazer from './pages/OQueFazer'
import InformacoesUteis from './pages/InformacoesUteis'
import Direitos from './pages/Direitos'
import Apoio from './pages/Apoio'
import NotFound from './pages/NotFound'

function App() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/trafico-de-seres-humanos-e-exploracao" element={<TraficoSeresHumanos />} />
                <Route path="/o-que-fazer" element={<OQueFazer />} />
                <Route path="/informacoes-uteis" element={<InformacoesUteis />} />
                <Route path="/direitos" element={<Direitos />} />
                <Route path="/apoio" element={<Apoio />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Layout>
    )
}

export default App
